import { ICONS } from '@/assets/icons';
import Iconify, { IconifyProps } from '@/components/Iconify';
import { ICON_SIZE_MAP } from '@/config';

export const DropdownIcon = (props: Omit<IconifyProps, 'icon'>) => (
  <Iconify {...props} icon={ICONS.CHEVRON_DOWN} width={ICON_SIZE_MAP.smPlus} height={ICON_SIZE_MAP.smPlus} />
);
